import React from "react";
import { Container, Top, Dia } from "./styles";

interface NumerodeDias{
    numdias?: number;
    hightLight?: number
}
export function Diasciclo({numdias, hightLight}: NumerodeDias){
    
    const nd = numdias ? numdias + 1 : numdias;

    return(
        <Container>
            <Top><span>Dias do<br />Ciclo</span></Top>
            {[...Array(nd)].map((_, i) => i > 0 && (<Dia className={`${hightLight === i-1 ? 'hover' : ''}`} key={i}>{i}</Dia>))}
        </Container>
    )
}